import React, { useState } from 'react';
import SalesEntryForm from '../../../components/finance/SalesEntryForm';
import SalesTable from '../../../components/finance/SalesTable';
import ExpenseEntryForm from '../../../components/finance/ExpenseEntryForm';
import ExpenseTable from '../../../components/finance/ExpenseTable';

type TransactionType = 'sales' | 'expenses';

const TransactionsTab: React.FC = () => {
  const [transactionType, setTransactionType] = useState<TransactionType>('sales');
  const [salesReloadKey, setSalesReloadKey] = useState(0);
  const [expensesReloadKey, setExpensesReloadKey] = useState(0);

  return (
    <div className="space-y-6">
      {/* Type Toggle */}
      <div className="flex items-center justify-between">
        <div className="inline-flex rounded-lg border border-gray-200 bg-white p-1">
          <button
            onClick={() => setTransactionType('sales')}
            className={`
              rounded-md px-4 py-2 text-sm font-semibold transition-all
              ${transactionType === 'sales'
                ? 'bg-primary text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
              }
            `}
          >
            💰 Sales
          </button>
          <button
            onClick={() => setTransactionType('expenses')}
            className={`
              rounded-md px-4 py-2 text-sm font-semibold transition-all
              ${transactionType === 'expenses'
                ? 'bg-primary text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
              }
            `}
          >
            💸 Expenses
          </button>
        </div>

        <div className="text-sm text-gray-500">
          {transactionType === 'sales' ? 'Record your sales' : 'Track your expenses'}
        </div>
      </div>

      {/* Sales View */}
      {transactionType === 'sales' && (
        <div className="space-y-6">
          <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Add Sale</h3>
            <SalesEntryForm onCreated={() => setSalesReloadKey(k => k + 1)} />
          </div>
          
          <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Recent Sales</h3>
            <div key={salesReloadKey}>
              <SalesTable />
            </div>
          </div>
        </div>
      )}

      {/* Expenses View */}
      {transactionType === 'expenses' && (
        <div className="space-y-6">
          <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Add Expense</h3>
            <ExpenseEntryForm onCreated={() => setExpensesReloadKey(k => k + 1)} />
          </div>
          
          <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Recent Expenses</h3>
            <div key={expensesReloadKey}>
              <ExpenseTable />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionsTab;
